import { Division, Region } from "@msidata/service-pro-api-schema";

export interface User {
    company?: string;
    companyData?: CompanyData;
    loginData?: LoginData;
    myDivision?: Division;
    myDefaultRegion?: Region;
    myRegions?: Region[];
    name?: string;
    email?: string;
}

export interface CompanyData {
    ApiVersionNumber: string;
    AppSettings: null;
    CompanyGuid: string;
    CompanyName: string;
    CompanyVersionNumber: string;
    CoreVersionNumber: string;
    Default;
    DivisionAndRegionEnabled: boolean;
    EmployeeDefaultRegionId: number;
    EmployeeDivisionId: number | null;
    EmployeeId: number;
    LocalizedLabels;
    Options: Options[];
    Rights;
    ScreensWithLookerDashboards: any;
    Settings;
    UiVersionNumber: null;
    UserDefinedFields: UserDefinedField[];
    UserDefinedLists: any[];
    UserPreferences?: any[];
    UserGroup;
}

export interface Options {
    Id: number;
    OptionNumber: string;
    Value: string;
    CreatedGroup: string;
    LastUpdatedDateTime: string;
    LastUpdatedUserId: number;
    CreatedDateTime: string;
    CreatedUserId: number;
    DeletedDateTime: string;
    IsDeleted: boolean;
}

export interface UserDefinedField {
    Id: number;
    TableName: string;
    FieldName: string;
    BindName: string;
    Required: boolean;
    DisplayValue: string;
    ShowOnDesktop: boolean;
    ShowOnMobile: boolean;
    ReadOnly: boolean;
    Type: string;
    Subtype: string | null;
    UserDefinedListId: number | null;
    fieldId?: string;
}

export interface LoginData {
    Companies;
    FirstName: string;
    FullName: string;
    LastName: string;
    SelectedCompanyId: number;
    Token: string;
    UserId: number;
    UserName: string;
    LocalizedLabels;
    set(key: string, value: any);
}

export const user: User = {};
